module.exports = __webpack_public_path__ + "static/media/about-us-quote-image.7a78af2a.webp";